module.exports = __webpack_public_path__ + "static/media/white-pencil.447342c2.svg";